import { useTranslation } from "react-i18next";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { LANGUAGES_ARRAY } from "../../constants/languages";
import Wrapper from "../wrapper";
import React, { useEffect } from "react";
import GlobalWidgets from "../widgets/GlobalWidgets";

const Layout = () => {
  const { locale = "en" } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (LANGUAGES_ARRAY.includes(locale)) {
      i18n.changeLanguage(locale);
    } else {
      navigate("/", { replace: true });
    }
  }, [locale, i18n, navigate]);

  return (
    <>
      <Wrapper>
        <GlobalWidgets />
        <Outlet />
      </Wrapper>
    </>
  );
};

export default Layout;
